module.exports = __webpack_public_path__ + "static/img/322.c321ce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/322.jpg
// module id = 2ucC
// module chunks = 0